var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCreateFromScratch = function SvgCreateFromScratch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CreateFromScratch_svg__CreateFromScratch_svg__clip0_178_714)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 11V9a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2h2",
    stroke: "#48525C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13l9 3-4 2-2 4-3-9zm-10-10v.01m4-.01v.01m4-.01v.01",
    stroke: "#48525C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3v.01M3.75 7v.01m0 3.99v.01m0 3.99v.01",
    stroke: "#6A6AA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CreateFromScratch_svg__CreateFromScratch_svg__clip0_178_714"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.75)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCreateFromScratch;